"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconVisible = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M64.88 33.81C64.34 33.21 51.31 19 35 19S5.66 33.21 5.12 33.81a1.78 1.78 0 0 0 0 2.37C5.66 36.79 18.69 51 35 51s29.34-14.21 29.88-14.81a1.78 1.78 0 0 0 0-2.38zM35 47.44A12.44 12.44 0 1 1 47.44 35 12.46 12.46 0 0 1 35 47.44z"
  }), _react["default"].createElement("path", {
    d: "M36.78 31.45A5.31 5.31 0 0 1 39 27.12a8.77 8.77 0 0 0-4-1 8.89 8.89 0 1 0 8.74 10.38 5.3 5.3 0 0 1-6.96-5.05z"
  })),
  height: undefined,
  width: undefined
});
IconVisible.displayName = 'IconVisible';
var _default = IconVisible;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/visible.js
// module id = 630
// module chunks = 0